import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  CancelButton,
  DownloadProgressIcon,
  DownloadProgressMessage,
  DownloadProgressText,
} from 'spw-programming-projects/downloads/styles';
import { SPWCircularProgress } from 'spw-shared/globalComponents/spinners';
import { colors } from 'spw-theme';
import { useDispatch, useSelector } from 'react-redux';
import EasternBlueCheck from 'spw-static/images/eastern-blue-check.svg';
import {
  cancelDownloadsInProgress,
  getDownloadsInProgress,
  getNumberOfDownloadsInProgress,
} from 'spw-redux/modules/downloads/actions';
import { selectNumberOfDownloadsInProgress } from 'spw-redux/modules/downloads/selectors';

export const DownloadProgressIndicator: React.FunctionComponent = () => {
  const delay = 3000;
  const dispatch = useDispatch();
  const callbackRef = useRef<ReturnType<typeof setTimeout>>();
  // The state will be updated once all downloads in progress have finished.
  const [shouldShowCompleteIcon] = useState(false);

  const cancelDownloads = () => {
    dispatch(cancelDownloadsInProgress());
  };

  useEffect(() => {
    dispatch(getDownloadsInProgress());
  }, [dispatch]);

  const numberOfDownloadsInProgress = useSelector(
    selectNumberOfDownloadsInProgress
  );

  const checkIfThereAreDownloadsInProgress = useCallback(() => {
    dispatch(getNumberOfDownloadsInProgress());
  }, [dispatch]);

  useEffect(() => {
    if (numberOfDownloadsInProgress && !callbackRef.current) {
      callbackRef.current = setInterval(
        checkIfThereAreDownloadsInProgress,
        delay
      );
    } else if (!numberOfDownloadsInProgress && callbackRef.current) {
      clearInterval(callbackRef.current);
      callbackRef.current = null;
    }
  }, [
    dispatch,
    numberOfDownloadsInProgress,
    checkIfThereAreDownloadsInProgress,
  ]);

  return numberOfDownloadsInProgress ? (
    <DownloadProgressMessage>
      <DownloadProgressText>
        <p>Downloading</p>
      </DownloadProgressText>
      <DownloadProgressIcon>
        {shouldShowCompleteIcon ? (
          <img src={EasternBlueCheck} alt="green-check" />
        ) : (
          <SPWCircularProgress color={colors.mainBlue} thickness={5} />
        )}
      </DownloadProgressIcon>
      <CancelButton onClick={cancelDownloads}>CANCEL</CancelButton>
    </DownloadProgressMessage>
  ) : null;
};
